module.exports = __webpack_public_path__ + "img/lbil_yellow.f7b42700.png";